import { Component, Input, OnInit } from '@angular/core';
import { ChatService } from '../../services/chat.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MessageTimestampComponent } from '../common/message-timestamp/message-timestamp.component';
import { MatCardModule } from '@angular/material/card';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { getYouTubeEmbedUrl, isYouTubeVideo } from '../../utils/helper';
import { MESSAGE_UNREAD_TEXT } from '../../utils/constants';

@Component({
  selector: 'app-dynamic-video',
  templateUrl: './dynamic-video.component.html',
  styleUrls: ['./dynamic-video.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MessageTimestampComponent,
    MatCardModule,
  ],
})
export class DynamicVideoComponent implements OnInit {
  @Input() input: any;
  @Input() isRead: boolean = false;

  config: any;
  messageText: string = '';
  messageUnreadText: string = MESSAGE_UNREAD_TEXT;

  constructor(
    private chatService: ChatService,
    private sanitizer: DomSanitizer
  ) {}

  get configs() {
    return this.chatService.configs;
  }

  ngOnInit() {
    this.config = this.input?.config;
    this.messageText = this.input?.message_text;
  }

  isYouTubeVideo(url: string): boolean {
    return isYouTubeVideo(url);
  }

  getSanitizedYouTubeUrl(url: string): SafeResourceUrl {
    const tempUrl = getYouTubeEmbedUrl(url);
    return this.sanitizer.bypassSecurityTrustResourceUrl(tempUrl);
  }
}
